module.exports = __webpack_public_path__ + "static/henrik_hose-db8e9d67d747f4511c980edec4bea753.png";